module.exports = __webpack_public_path__ + "img/移位.96a4440c.svg";